import { LocalStorageKey } from "./localStoragePersistence/common/LocalStorageKey";

export const HomeLocalStorageKeys = {
  isShortHelpDialogOpenKey: new LocalStorageKey(
    "Home",
    "isShortHelpDialogOpen",
  ),
  isCrewDialogOpenKey: new LocalStorageKey("Home", "isCrewDialogOpen"),
  currentCrewIdentifierKey: new LocalStorageKey(
    "Home",
    "currentCrewIdentifier",
  ),
} as const;
